import React from 'react';
import { DialogUI } from '../Interface';
import { Box } from '@mui/material';
import { TaskListReportPage } from './TaskListReportPage';

const TaskListReportDialog = ({ open, handleClose, data, setTaskChanged }) => {
  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Feladatlista lejelentő"
      closeBtn={true}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
            mx: 1,
          },
        },
      }}
    >
      <Box mt="1rem">
        <TaskListReportPage data={data} handleClose={handleClose} setTaskChanged={setTaskChanged} />
      </Box>
    </DialogUI>
  );
};

export default TaskListReportDialog;
